import { useEffect, useState } from 'react'

/**
 * Calculate the heading's level of a node reference.
 *
 * @param {import('react').RefObject<Node>} elementRef
 * @param {number?} defaultLevel
 * @returns {number}
 */
export default function useHeadingLevel (elementRef, defaultLevel = 2) {
  const [headingLevel, setHeadingLevel] = useState(defaultLevel)
  useEffect(() => {
    if (elementRef.current) {
      setHeadingLevel(getHeaderLevel(elementRef.current, defaultLevel))
    }
  }, [elementRef.current])
  return headingLevel
}

/**
 * @param {Node} node
 * @returns {number}
 */
function getHeaderLevel (node, defaultLevel) {
  let sameLevel = true
  do {
    if (node && node.previousSibling) {
      node = node.previousSibling
      const { tagName } = node
      if (tagName) {
        if (/^H[1-6]$/.test(tagName)) return getLevel(tagName, sameLevel)
        const header = node.querySelector('h1, h2, h3, h4, h5, h6')
        if (header) return getLevel(header.tagName, sameLevel)
      }
    } else {
      node = node && node.parentNode
      sameLevel = false
    }
  } while (node && node !== document.body)
  return defaultLevel
}

/**
 * @param {'h1'|'h2'|'h3'|'h4'|'h5'|'h6'} tagName
 * @param {boolean} sameLevel
 * @returns {number}
 */
function getLevel (tagName, sameLevel) {
  const level = Number(tagName[1]) + (sameLevel ? 0 : 1)
  if (level <= 1) return 2
  if (level >= 6) return 6
  return level
}
